import { instance } from "..";

// /api/community — discovery rails, feed, search, mode detail, comments and
// the public share preview. Functions throw; callers use react-query.

// True once a community endpoint answers 404 / 501: the server doesn't have
// this API yet, so pages fall back to the previous endpoints.
let unavailable = false;
export const isCommunityApiUnavailable = () => unavailable;
const notDeployed = (error) => [404, 501].includes(error?.response?.status);

const guarded = async (request) => {
  try {
    const { data } = await request();
    return data;
  } catch (error) {
    if (notDeployed(error)) unavailable = true;
    throw error;
  }
};

export const getDiscover = () => guarded(() => instance.get("/api/community/discover"));

// params: { sort, category, difficulty }
export const getFeed = (params = {}, cursor) =>
  guarded(() =>
    instance.get("/api/community/feed", {
      params: { ...params, cursor: cursor || undefined, limit: 20 },
    }),
  );

export const searchCommunity = (params = {}, cursor) =>
  guarded(() =>
    instance.get("/api/community/search", {
      params: { ...params, cursor: cursor || undefined, limit: 20 },
    }),
  );

export const getModeDetail = async (modeId) => {
  const { data } = await instance.get(`/api/community/modes/${modeId}`);
  return data;
};

export const getModeComments = async (modeId, cursor) => {
  const { data } = await instance.get(`/api/community/modes/${modeId}/comments`, {
    params: { cursor: cursor || undefined, limit: 20 },
  });
  return data;
};

export const postModeComment = async (modeId, content) => {
  const { data } = await instance.post(`/api/community/modes/${modeId}/comments`, { content });
  return data.comment;
};

export const deleteModeComment = async (modeId, commentId) => {
  const { data } = await instance.delete(`/api/community/modes/${modeId}/comments/${commentId}`);
  return data;
};

export const hideModeComment = async (modeId, commentId) => {
  const { data } = await instance.patch(`/api/community/modes/${modeId}/comments/${commentId}/hide`);
  return data;
};

// Public (no login): name, image, question count and creator of a published mode.
export const getSharePreview = async (idOrCode) => {
  const { data } = await instance.get(`/api/community/share/${encodeURIComponent(idOrCode)}`);
  return data;
};
